import React, { useEffect } from 'react';
import { List, Datagrid, FunctionField } from 'react-admin';

function ArchivoPatrimonialList(props: any) {
  useEffect(() => {
    document.title = 'FG Archivo Patrimonial - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">

        <FunctionField
          label="Descripción"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || '';
            return <span>{text ? `${text.substring(0, 90)}...` : 'Sin contenido'}</span>;
          }}
        />

        <FunctionField
          label="Slides Hero"
          render={(record: any) => {
            let total = 0;
            if (Array.isArray(record.heroItem)) {
              total = record.heroItem.length;
            } else if (Array.isArray(record.hero)) {
              total = record.hero.length;
            }

            return <span>{total}</span>;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default ArchivoPatrimonialList;
